import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=bd08f33a&scoped=true"
import script from "./CustomFields.vue?vue&type=script&lang=js"
export * from "./CustomFields.vue?vue&type=script&lang=js"
import style0 from "./CustomFields.vue?vue&type=style&index=0&id=bd08f33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd08f33a",
  null
  
)

export default component.exports